import { TemplateHomeMenuDto } from "@domain/project/template/property/general/homeMenu/template-home-menu.dto";
import { TemplateMainMenuDto } from "@domain/project/template/property/general/mainMenu/template-main-menu.dto";
import { Type } from "class-transformer";
import { IsOptional } from "class-validator";

export class TemplateGeneralDto {
  @IsOptional()
  @Type(() => TemplateMainMenuDto)
  mainMenu?: TemplateMainMenuDto;

  @IsOptional()
  @Type(() => TemplateHomeMenuDto)
  homeMenu?: TemplateHomeMenuDto;
}
